import { SolutionSelectedByDilemmaOwner } from "..";
import { ChosenDilemmaCard } from "../../molecules/Board/subBoardComponents";
import crownPink from "../../../assets/icons/crownPink.svg";
import confetti from "canvas-confetti";
import { useContext, useEffect } from "react";
import { BoardContext } from "../../../context";
import { useTranslation } from "react-i18next";

interface CustomHTMLElement extends HTMLCanvasElement {
    confetti: any;
}

const DilemmaAndPickedSolutionCards = () => {
    const { t } = useTranslation();
    const { setAreStrengthsShownFullScreen } = useContext(BoardContext);

    useEffect(() => {
        addConfetti();
    }, []);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setAreStrengthsShownFullScreen(true);
        }, 7000);

        return () => clearTimeout(timeout);
    }, [setAreStrengthsShownFullScreen]);

    const addConfetti = () => {
        const htmlCanvas = document.getElementById("confeti") as CustomHTMLElement;

        htmlCanvas!.confetti = htmlCanvas!.confetti || confetti.create(htmlCanvas, { resize: true });
        htmlCanvas!.confetti({
            particleCount: 300,
            angle: 90,
            spread: 180,
            gravity: 1,
            zIndex: 1,
            startVelocity: 50,
            scalar: 1,
            colors: ["#53BD8B", "#FF00A7", "#005776", "#FED100"],
            resize: true
        });
    }

    return(
        <div className="dilemma_owner_anouncement_wrapper dilemma_and_picked_solution_cards_wrapper center_horizontally_and_vertically full_screen_vw_vh">
            <div className="dilemma_and_picked_solution_cards_title center_horizontally_and_vertically"> 
                <div>{t("theWinningSolutionIs")} </div>
                <div className="gradient_line_holder center_horizontally_and_vertically" style={{height: "3vh", width: "60%"}}>
                    <div className="linear_gradient_line_horizontal" style={{ width: "100%" }}></div>
                </div>  
            </div>
            <div className="dilemma_and_picked_solution_cards">
                <div className="dilemma_and_picked_solution_cards_dilemma"> 
                    <ChosenDilemmaCard isFullScreenOn={true} isTheFullScreenOn={true} />
                </div>
                <div className="dilemma_and_picked_solution_cards_solution">
                    <div className="dilemma_and_picked_solution_cards_animation center_horizontally_and_vertically"> 
                        <img className="dilemma_and_picked_solution_cards_crown" src={crownPink} alt="pink crown" /> 
                        <canvas id="confeti" style={{ position: 'absolute', width: '100vw', height: '100vh' }} />
                    </div>
                    <SolutionSelectedByDilemmaOwner /> 
                </div>
            </div>
        </div>
    )
}

export default DilemmaAndPickedSolutionCards;